/** POC getMachineOverrideSignature — auto-feed switched Off sends autoFedTypes:0 in calc body. */
export function mspOverrideSignature(autoFeedOn: boolean): string {
  return autoFeedOn ? "" : "autoFedTypes:0";
}

export function mspModelConstantOverrides(
  autoFeedOn: boolean,
): { autoFedTypes?: string } | undefined {
  return autoFeedOn ? undefined : { autoFedTypes: "0" };
}
